import {QueryValue} from '.';
import {Operator} from '../../consts/operators';

export type filterType = {values: string[]; operator: Operator};

export function serialize(queryValue: QueryValue): filterType {
    const {fromval, FromValues, op} = queryValue;
    let operator;
    let textValues = [];
    let seralizedValues;
    if (fromval === 'NULL') {
        return {
            values: [''],
            operator: op === '<>' ? Operator.NotEmpty : Operator.Empty
        };
    }
    if (FromValues && FromValues[0]) {
        FromValues[0].Value.forEach(value => {
            value.value && textValues.push(value.value);
        });
    } else if (fromval) {
        textValues = [fromval];
    }

    textValues.forEach(value => {
        if (op === '=' || op === undefined) {
            if (
                value.charAt(0) === '*' &&
                value.charAt(value.length - 1) === '*' &&
                (operator === undefined || operator === Operator.Contains)
            ) {
                operator = Operator.Contains;
            } else if (
                value.charAt(0) === '*' &&
                (operator === undefined || operator === Operator.EndsWith)
            ) {
                operator = Operator.EndsWith;
            } else if (
                value.charAt(value.length - 1) === '*' &&
                (operator === undefined || operator === Operator.StartsWith)
            ) {
                operator = Operator.StartsWith;
            } else {
                operator = Operator.Equals;
            }
        } else if (op === '<>') {
            operator = Operator.NotEquals;
        } else if (op === '>') {
            operator = Operator.Greater;
        } else if (op === '<') {
            operator = Operator.Less;
        } else {
            operator = Operator.Equals;
        }
    });

    if (
        operator === Operator.Contains ||
        operator === Operator.EndsWith ||
        operator === Operator.StartsWith
    ) {
        seralizedValues = textValues.map(value => {
            if (value !== '*') {
                return value.replace(/\*/g, '');
            } else {
                return value;
            }
        });
    } else {
        seralizedValues = textValues;
    }

    return {
        values: seralizedValues,
        operator: operator === undefined ? Operator.Equals : operator
    };
}

export function deserialize({operator, values}: filterType): Partial<QueryValue> {
    let modifier: (value: string) => string;
    switch (operator) {
        case Operator.Contains:
            modifier = value => '*' + value + '*';
            break;
        case Operator.EndsWith:
            modifier = value => '*' + value;
            break;
        case Operator.StartsWith:
            modifier = value => value + '*';
            break;
        case Operator.Empty:
        case Operator.NotEmpty:
            values = ['NULL'];
            modifier = value => 'NULL';
            break;
        default:
            modifier = value => value;
            break;
    }
    const tables = [
        {
            tableName: 'FromValues',
            rows: [
                {
                    tables: values.map(value => {
                        return {
                            tableName: 'Value',
                            rows: [{value: modifier(value)}]
                        };
                    })
                }
            ]
        }
    ];

    if (operator === Operator.NotEquals || operator === Operator.NotEmpty) {
        return {
            tables: tables,
            op: '<>'
        };
    } else if (operator === Operator.Greater) {
        return {
            tables: tables,
            op: '>'
        };
    } else if (operator === Operator.Less) {
        return {
            tables: tables,
            op: '<'
        };
    }
    return {
        tables: tables,
        op: '='
    };
}
